import { UserCartProvider } from '@/hooks/use-user-global-cart';
import { type ReactNode } from 'react';

interface UserCartLayoutProps {
    children: ReactNode;
}


export default function UserCartLayout({ children }: UserCartLayoutProps) {
    return (
        <UserCartProvider>
            {children}
        </UserCartProvider>
    );
}
